import { useEffect } from "react";
import { BASE_PATH } from "@/lib/api";

export function Seo({ title, description, canonicalPath, noindex }) {
  useEffect(() => {
    if (title) document.title = title;
    const set = (selector, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement(attrs.rel ? "link" : "meta");
        document.head.appendChild(el);
      }
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
      return el;
    };

    if (description) {
      set('meta[name="description"]', { name: "description", content: description });
    }
    if (canonicalPath) {
      set('link[rel="canonical"]', {
        rel: "canonical",
        href: `${window.location.origin}${BASE_PATH}${canonicalPath}`,
      });
    }
    set('meta[name="robots"]', {
      name: "robots",
      content: noindex ? "noindex, nofollow" : "index, follow",
    });
  }, [title, description, canonicalPath, noindex]);

  return null;
}
